/**
 * Comprehensive Exercise Library
 * 100+ workouts with complete attributes for fitness tracking
 * Calories are calculated per minute for accurate tracking
 */

export const exerciseDatabase = [
  // CARDIO EXERCISES
  {
    id: 'cardio-1',
    name: 'Correr (Running)',
    category: 'Cardio',
    caloriesPerMinute: 15,
    intensity: 'high',
    muscleGroups: ['Piernas', 'Glúteos', 'Core'],
    equipment: 'Ninguno',
    difficulty: 'Intermedio',
    defaultDuration: 30,
    description: 'Ejercicio cardiovascular de alto impacto que mejora la resistencia y quema calorías eficientemente',
    instructions: '1. Mantén una postura erguida\n2. Aterriza con la parte media del pie\n3. Mantén los brazos en ángulo de 90 grados\n4. Respira de manera constante'
  },
  {
    id: 'cardio-2',
    name: 'Caminar Rápido (Brisk Walking)',
    category: 'Cardio',
    caloriesPerMinute: 5,
    intensity: 'low',
    muscleGroups: ['Piernas', 'Glúteos'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 45,
    description: 'Ejercicio cardiovascular de bajo impacto ideal para principiantes',
    instructions: '1. Mantén un ritmo constante\n2. Balancea los brazos naturalmente\n3. Mantén la cabeza erguida\n4. Respira profundamente'
  },
  {
    id: 'cardio-3',
    name: 'Ciclismo (Cycling)',
    category: 'Cardio',
    caloriesPerMinute: 12,
    intensity: 'moderate',
    muscleGroups: ['Piernas', 'Glúteos', 'Cuádriceps'],
    equipment: 'Bicicleta',
    difficulty: 'Intermedio',
    defaultDuration: 40,
    description: 'Ejercicio cardiovascular de bajo impacto excelente para las articulaciones',
    instructions: '1. Ajusta el asiento a la altura correcta\n2. Mantén las rodillas alineadas\n3. Pedalea con movimientos circulares suaves\n4. Mantén el core activado'
  },
  {
    id: 'cardio-4',
    name: 'Natación (Swimming)',
    category: 'Cardio',
    caloriesPerMinute: 14,
    intensity: 'moderate',
    muscleGroups: ['Cuerpo Completo', 'Brazos', 'Piernas', 'Core'],
    equipment: 'Piscina',
    difficulty: 'Intermedio',
    defaultDuration: 30,
    description: 'Ejercicio de cuerpo completo con resistencia del agua',
    instructions: '1. Mantén una técnica de respiración adecuada\n2. Alterna entre diferentes estilos\n3. Mantén el cuerpo alineado\n4. Descansa entre series'
  },
  {
    id: 'cardio-5',
    name: 'Saltar la Cuerda (Jump Rope)',
    category: 'Cardio',
    caloriesPerMinute: 16,
    intensity: 'high',
    muscleGroups: ['Pantorrillas', 'Piernas', 'Hombros', 'Core'],
    equipment: 'Cuerda',
    difficulty: 'Intermedio',
    defaultDuration: 15,
    description: 'Ejercicio cardiovascular intenso que mejora la coordinación',
    instructions: '1. Salta con la punta de los pies\n2. Mantén los codos cerca del cuerpo\n3. Gira la cuerda con las muñecas\n4. Mantén un ritmo constante'
  },
  {
    id: 'cardio-6',
    name: 'Remo (Rowing)',
    category: 'Cardio',
    caloriesPerMinute: 13,
    intensity: 'moderate',
    muscleGroups: ['Espalda', 'Brazos', 'Piernas', 'Core'],
    equipment: 'Máquina de Remo',
    difficulty: 'Intermedio',
    defaultDuration: 25,
    description: 'Ejercicio de cuerpo completo con bajo impacto en las articulaciones',
    instructions: '1. Empuja con las piernas primero\n2. Inclínate ligeramente hacia atrás\n3. Tira del manillar hacia el pecho\n4. Mantén el core activado'
  },
  {
    id: 'cardio-7',
    name: 'Elíptica (Elliptical)',
    category: 'Cardio',
    caloriesPerMinute: 11,
    intensity: 'moderate',
    muscleGroups: ['Piernas', 'Glúteos', 'Brazos'],
    equipment: 'Máquina Elíptica',
    difficulty: 'Principiante',
    defaultDuration: 35,
    description: 'Ejercicio cardiovascular de bajo impacto para todo el cuerpo',
    instructions: '1. Mantén una postura erguida\n2. Usa los brazos activamente\n3. Mantén un ritmo constante\n4. Varía la resistencia'
  },
  {
    id: 'cardio-8',
    name: 'Burpees',
    category: 'Cardio',
    caloriesPerMinute: 18,
    intensity: 'extreme',
    muscleGroups: ['Cuerpo Completo', 'Core', 'Piernas', 'Pecho'],
    equipment: 'Ninguno',
    difficulty: 'Avanzado',
    defaultDuration: 10,
    description: 'Ejercicio de cuerpo completo de alta intensidad',
    instructions: '1. Comienza de pie\n2. Baja a posición de plancha\n3. Haz una flexión\n4. Salta hacia arriba con los brazos extendidos'
  },
  {
    id: 'cardio-9',
    name: 'Mountain Climbers',
    category: 'Cardio',
    caloriesPerMinute: 14,
    intensity: 'high',
    muscleGroups: ['Core', 'Piernas', 'Hombros'],
    equipment: 'Ninguno',
    difficulty: 'Intermedio',
    defaultDuration: 12,
    description: 'Ejercicio cardiovascular que fortalece el core',
    instructions: '1. Comienza en posición de plancha\n2. Lleva las rodillas al pecho alternadamente\n3. Mantén el core apretado\n4. Mantén un ritmo rápido'
  },
  {
    id: 'cardio-10',
    name: 'Jumping Jacks',
    category: 'Cardio',
    caloriesPerMinute: 10,
    intensity: 'moderate',
    muscleGroups: ['Piernas', 'Hombros', 'Core'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 15,
    description: 'Ejercicio cardiovascular clásico para calentamiento',
    instructions: '1. Comienza con pies juntos\n2. Salta abriendo piernas y brazos\n3. Regresa a la posición inicial\n4. Mantén un ritmo constante'
  },
  {
    id: 'cardio-11',
    name: 'Escaladora (Stair Climber)',
    category: 'Cardio',
    caloriesPerMinute: 13,
    intensity: 'high',
    muscleGroups: ['Piernas', 'Glúteos', 'Pantorrillas'],
    equipment: 'Máquina Escaladora',
    difficulty: 'Intermedio',
    defaultDuration: 20,
    description: 'Ejercicio cardiovascular que tonifica piernas y glúteos',
    instructions: '1. Mantén una postura erguida\n2. No te apoyes en los manillares\n3. Usa todo el pie en cada paso\n4. Mantén un ritmo constante'
  },
  {
    id: 'cardio-12',
    name: 'Boxeo de Sombra (Shadow Boxing)',
    category: 'Cardio',
    caloriesPerMinute: 12,
    intensity: 'moderate',
    muscleGroups: ['Brazos', 'Hombros', 'Core'],
    equipment: 'Ninguno',
    difficulty: 'Intermedio',
    defaultDuration: 20,
    description: 'Ejercicio cardiovascular que mejora la coordinación y agilidad',
    instructions: '1. Mantén una postura de boxeo\n2. Lanza golpes con técnica\n3. Mantén el core activado\n4. Muévete constantemente'
  },
  {
    id: 'cardio-13',
    name: 'High Knees',
    category: 'Cardio',
    caloriesPerMinute: 13,
    intensity: 'high',
    muscleGroups: ['Piernas', 'Core', 'Glúteos'],
    equipment: 'Ninguno',
    difficulty: 'Intermedio',
    defaultDuration: 10,
    description: 'Ejercicio cardiovascular de alta intensidad',
    instructions: '1. Corre en el lugar\n2. Eleva las rodillas al pecho\n3. Mantén el core apretado\n4. Balancea los brazos activamente'
  },
  {
    id: 'cardio-14',
    name: 'Senderismo (Hiking)',
    category: 'Cardio',
    caloriesPerMinute: 9,
    intensity: 'moderate',
    muscleGroups: ['Piernas', 'Glúteos', 'Core'],
    equipment: 'Ninguno',
    difficulty: 'Intermedio',
    defaultDuration: 60,
    description: 'Ejercicio cardiovascular al aire libre con beneficios mentales',
    instructions: '1. Usa calzado apropiado\n2. Mantén un ritmo constante\n3. Hidrátate regularmente\n4. Disfruta la naturaleza'
  },
  {
    id: 'cardio-15',
    name: 'Spinning',
    category: 'Cardio',
    caloriesPerMinute: 14,
    intensity: 'high',
    muscleGroups: ['Piernas', 'Glúteos', 'Core'],
    equipment: 'Bicicleta Estática',
    difficulty: 'Intermedio',
    defaultDuration: 45,
    description: 'Clase de ciclismo indoor de alta intensidad',
    instructions: '1. Ajusta la bicicleta correctamente\n2. Sigue el ritmo de la música\n3. Varía la resistencia\n4. Mantén el core activado'
  },

  // STRENGTH TRAINING - UPPER BODY
  {
    id: 'strength-1',
    name: 'Press de Banca (Bench Press)',
    category: 'Fuerza - Pecho',
    caloriesPerMinute: 8,
    intensity: 'high',
    muscleGroups: ['Pecho', 'Tríceps', 'Hombros'],
    equipment: 'Barra y Banco',
    difficulty: 'Intermedio',
    defaultDuration: 20,
    description: 'Ejercicio fundamental para desarrollar el pecho',
    instructions: '1. Acuéstate en el banco\n2. Agarra la barra con las manos al ancho de hombros\n3. Baja la barra al pecho\n4. Empuja hacia arriba con fuerza'
  },
  {
    id: 'strength-2',
    name: 'Flexiones (Push-ups)',
    category: 'Fuerza - Pecho',
    caloriesPerMinute: 7,
    intensity: 'moderate',
    muscleGroups: ['Pecho', 'Tríceps', 'Hombros', 'Core'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Ejercicio clásico de peso corporal para el pecho',
    instructions: '1. Posición de plancha con manos al ancho de hombros\n2. Baja el cuerpo hasta casi tocar el suelo\n3. Mantén el core apretado\n4. Empuja hacia arriba'
  },
  {
    id: 'strength-3',
    name: 'Press Militar (Military Press)',
    category: 'Fuerza - Hombros',
    caloriesPerMinute: 8,
    intensity: 'high',
    muscleGroups: ['Hombros', 'Tríceps', 'Core'],
    equipment: 'Barra o Mancuernas',
    difficulty: 'Intermedio',
    defaultDuration: 15,
    description: 'Ejercicio principal para desarrollar hombros fuertes',
    instructions: '1. De pie con la barra a la altura de los hombros\n2. Empuja la barra hacia arriba\n3. Mantén el core activado\n4. Baja con control'
  },
  {
    id: 'strength-4',
    name: 'Elevaciones Laterales (Lateral Raises)',
    category: 'Fuerza - Hombros',
    caloriesPerMinute: 6,
    intensity: 'moderate',
    muscleGroups: ['Hombros', 'Deltoides'],
    equipment: 'Mancuernas',
    difficulty: 'Principiante',
    defaultDuration: 12,
    description: 'Ejercicio de aislamiento para los hombros',
    instructions: '1. De pie con mancuernas a los lados\n2. Eleva los brazos lateralmente\n3. Mantén una ligera flexión en los codos\n4. Baja con control'
  },
  {
    id: 'strength-5',
    name: 'Dominadas (Pull-ups)',
    category: 'Fuerza - Espalda',
    caloriesPerMinute: 10,
    intensity: 'high',
    muscleGroups: ['Espalda', 'Bíceps', 'Core'],
    equipment: 'Barra de Dominadas',
    difficulty: 'Avanzado',
    defaultDuration: 10,
    description: 'Ejercicio de peso corporal para la espalda superior',
    instructions: '1. Cuelga de la barra con agarre amplio\n2. Tira hacia arriba hasta que la barbilla pase la barra\n3. Mantén el core apretado\n4. Baja con control'
  },
  {
    id: 'strength-6',
    name: 'Remo con Barra (Barbell Row)',
    category: 'Fuerza - Espalda',
    caloriesPerMinute: 9,
    intensity: 'high',
    muscleGroups: ['Espalda', 'Bíceps', 'Core'],
    equipment: 'Barra',
    difficulty: 'Intermedio',
    defaultDuration: 15,
    description: 'Ejercicio compuesto para la espalda media',
    instructions: '1. Inclínate hacia adelante con la espalda recta\n2. Tira de la barra hacia el abdomen\n3. Aprieta los omóplatos\n4. Baja con control'
  },
  {
    id: 'strength-7',
    name: 'Curl de Bíceps (Bicep Curls)',
    category: 'Fuerza - Brazos',
    caloriesPerMinute: 5,
    intensity: 'moderate',
    muscleGroups: ['Bíceps'],
    equipment: 'Mancuernas o Barra',
    difficulty: 'Principiante',
    defaultDuration: 12,
    description: 'Ejercicio de aislamiento para los bíceps',
    instructions: '1. De pie con mancuernas a los lados\n2. Flexiona los codos llevando las mancuernas hacia los hombros\n3. Mantén los codos fijos\n4. Baja con control'
  },
  {
    id: 'strength-8',
    name: 'Extensiones de Tríceps (Tricep Extensions)',
    category: 'Fuerza - Brazos',
    caloriesPerMinute: 5,
    intensity: 'moderate',
    muscleGroups: ['Tríceps'],
    equipment: 'Mancuerna o Cable',
    difficulty: 'Principiante',
    defaultDuration: 12,
    description: 'Ejercicio de aislamiento para los tríceps',
    instructions: '1. Sostén una mancuerna sobre la cabeza\n2. Baja el peso detrás de la cabeza\n3. Mantén los codos fijos\n4. Extiende hacia arriba'
  },
  {
    id: 'strength-9',
    name: 'Fondos en Paralelas (Dips)',
    category: 'Fuerza - Brazos',
    caloriesPerMinute: 9,
    intensity: 'high',
    muscleGroups: ['Tríceps', 'Pecho', 'Hombros'],
    equipment: 'Barras Paralelas',
    difficulty: 'Intermedio',
    defaultDuration: 10,
    description: 'Ejercicio compuesto de peso corporal para tríceps',
    instructions: '1. Sujétate en las barras paralelas\n2. Baja el cuerpo flexionando los codos\n3. Mantén el core activado\n4. Empuja hacia arriba'
  },
  {
    id: 'strength-10',
    name: 'Aperturas con Mancuernas (Dumbbell Flyes)',
    category: 'Fuerza - Pecho',
    caloriesPerMinute: 6,
    intensity: 'moderate',
    muscleGroups: ['Pecho', 'Hombros'],
    equipment: 'Mancuernas y Banco',
    difficulty: 'Intermedio',
    defaultDuration: 12,
    description: 'Ejercicio de aislamiento para el pecho',
    instructions: '1. Acuéstate en el banco con mancuernas\n2. Abre los brazos en forma de arco\n3. Mantén una ligera flexión en los codos\n4. Junta las mancuernas arriba'
  },

  // STRENGTH TRAINING - LOWER BODY
  {
    id: 'strength-11',
    name: 'Sentadillas (Squats)',
    category: 'Fuerza - Piernas',
    caloriesPerMinute: 10,
    intensity: 'high',
    muscleGroups: ['Cuádriceps', 'Glúteos', 'Isquiotibiales', 'Core'],
    equipment: 'Barra (opcional)',
    difficulty: 'Intermedio',
    defaultDuration: 20,
    description: 'Ejercicio fundamental para piernas y glúteos',
    instructions: '1. Pies al ancho de hombros\n2. Baja como si te sentaras\n3. Mantén las rodillas alineadas con los pies\n4. Empuja con los talones para subir'
  },
  {
    id: 'strength-12',
    name: 'Peso Muerto (Deadlifts)',
    category: 'Fuerza - Piernas',
    caloriesPerMinute: 11,
    intensity: 'high',
    muscleGroups: ['Isquiotibiales', 'Glúteos', 'Espalda Baja', 'Core'],
    equipment: 'Barra',
    difficulty: 'Avanzado',
    defaultDuration: 15,
    description: 'Ejercicio compuesto para la cadena posterior',
    instructions: '1. Pies al ancho de caderas\n2. Agarra la barra con las manos fuera de las piernas\n3. Mantén la espalda recta\n4. Levanta empujando con las piernas'
  },
  {
    id: 'strength-13',
    name: 'Zancadas (Lunges)',
    category: 'Fuerza - Piernas',
    caloriesPerMinute: 8,
    intensity: 'moderate',
    muscleGroups: ['Cuádriceps', 'Glúteos', 'Isquiotibiales'],
    equipment: 'Mancuernas (opcional)',
    difficulty: 'Principiante',
    defaultDuration: 15,
    description: 'Ejercicio unilateral para piernas y equilibrio',
    instructions: '1. Da un paso largo hacia adelante\n2. Baja la rodilla trasera hacia el suelo\n3. Mantén el torso erguido\n4. Empuja con el talón delantero para volver'
  },
  {
    id: 'strength-14',
    name: 'Prensa de Piernas (Leg Press)',
    category: 'Fuerza - Piernas',
    caloriesPerMinute: 9,
    intensity: 'high',
    muscleGroups: ['Cuádriceps', 'Glúteos', 'Isquiotibiales'],
    equipment: 'Máquina de Prensa',
    difficulty: 'Principiante',
    defaultDuration: 15,
    description: 'Ejercicio de máquina para desarrollo de piernas',
    instructions: '1. Coloca los pies en la plataforma\n2. Empuja la plataforma con los talones\n3. Baja con control\n4. No bloquees las rodillas arriba'
  },
  {
    id: 'strength-15',
    name: 'Curl de Piernas (Leg Curls)',
    category: 'Fuerza - Piernas',
    caloriesPerMinute: 6,
    intensity: 'moderate',
    muscleGroups: ['Isquiotibiales'],
    equipment: 'Máquina de Curl',
    difficulty: 'Principiante',
    defaultDuration: 12,
    description: 'Ejercicio de aislamiento para isquiotibiales',
    instructions: '1. Acuéstate boca abajo en la máquina\n2. Flexiona las piernas llevando los talones hacia los glúteos\n3. Aprieta los isquiotibiales\n4. Baja con control'
  },
  {
    id: 'strength-16',
    name: 'Extensiones de Piernas (Leg Extensions)',
    category: 'Fuerza - Piernas',
    caloriesPerMinute: 6,
    intensity: 'moderate',
    muscleGroups: ['Cuádriceps'],
    equipment: 'Máquina de Extensión',
    difficulty: 'Principiante',
    defaultDuration: 12,
    description: 'Ejercicio de aislamiento para cuádriceps',
    instructions: '1. Siéntate en la máquina\n2. Extiende las piernas hacia arriba\n3. Aprieta los cuádriceps\n4. Baja con control'
  },
  {
    id: 'strength-17',
    name: 'Elevaciones de Pantorrillas (Calf Raises)',
    category: 'Fuerza - Piernas',
    caloriesPerMinute: 5,
    intensity: 'low',
    muscleGroups: ['Pantorrillas'],
    equipment: 'Ninguno o Máquina',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Ejercicio para fortalecer las pantorrillas',
    instructions: '1. De pie con los pies al ancho de caderas\n2. Eleva los talones lo más alto posible\n3. Mantén el equilibrio\n4. Baja con control'
  },
  {
    id: 'strength-18',
    name: 'Puente de Glúteos (Glute Bridge)',
    category: 'Fuerza - Piernas',
    caloriesPerMinute: 6,
    intensity: 'moderate',
    muscleGroups: ['Glúteos', 'Isquiotibiales', 'Core'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 12,
    description: 'Ejercicio de activación de glúteos',
    instructions: '1. Acuéstate boca arriba con rodillas flexionadas\n2. Eleva las caderas hacia el techo\n3. Aprieta los glúteos arriba\n4. Baja con control'
  },
  {
    id: 'strength-19',
    name: 'Sentadilla Búlgara (Bulgarian Split Squat)',
    category: 'Fuerza - Piernas',
    caloriesPerMinute: 9,
    intensity: 'high',
    muscleGroups: ['Cuádriceps', 'Glúteos', 'Isquiotibiales'],
    equipment: 'Banco',
    difficulty: 'Intermedio',
    defaultDuration: 15,
    description: 'Ejercicio unilateral avanzado para piernas',
    instructions: '1. Coloca un pie en un banco detrás de ti\n2. Baja la rodilla trasera hacia el suelo\n3. Mantén el torso erguido\n4. Empuja con el talón delantero'
  },
  {
    id: 'strength-20',
    name: 'Step-ups',
    category: 'Fuerza - Piernas',
    caloriesPerMinute: 8,
    intensity: 'moderate',
    muscleGroups: ['Cuádriceps', 'Glúteos', 'Isquiotibiales'],
    equipment: 'Banco o Caja',
    difficulty: 'Principiante',
    defaultDuration: 15,
    description: 'Ejercicio funcional para piernas',
    instructions: '1. Coloca un pie en el banco\n2. Empuja con ese pie para subir\n3. Baja con control\n4. Alterna las piernas'
  },

  // CORE EXERCISES
  {
    id: 'core-1',
    name: 'Plancha (Plank)',
    category: 'Core',
    caloriesPerMinute: 5,
    intensity: 'moderate',
    muscleGroups: ['Core', 'Abdominales', 'Espalda Baja'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 5,
    description: 'Ejercicio isométrico fundamental para el core',
    instructions: '1. Posición de flexión sobre los antebrazos\n2. Mantén el cuerpo en línea recta\n3. Aprieta el core\n4. Respira normalmente'
  },
  {
    id: 'core-2',
    name: 'Abdominales (Crunches)',
    category: 'Core',
    caloriesPerMinute: 6,
    intensity: 'moderate',
    muscleGroups: ['Abdominales'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Ejercicio clásico para abdominales',
    instructions: '1. Acuéstate boca arriba con rodillas flexionadas\n2. Eleva el torso hacia las rodillas\n3. Mantén las manos en el pecho o detrás de la cabeza\n4. Baja con control'
  },
  {
    id: 'core-3',
    name: 'Bicicleta (Bicycle Crunches)',
    category: 'Core',
    caloriesPerMinute: 8,
    intensity: 'moderate',
    muscleGroups: ['Abdominales', 'Oblicuos'],
    equipment: 'Ninguno',
    difficulty: 'Intermedio',
    defaultDuration: 10,
    description: 'Ejercicio dinámico para abdominales y oblicuos',
    instructions: '1. Acuéstate boca arriba\n2. Lleva el codo al rodilla opuesta\n3. Alterna los lados en movimiento de pedaleo\n4. Mantén el core apretado'
  },
  {
    id: 'core-4',
    name: 'Elevación de Piernas (Leg Raises)',
    category: 'Core',
    caloriesPerMinute: 7,
    intensity: 'moderate',
    muscleGroups: ['Abdominales Inferiores', 'Core'],
    equipment: 'Ninguno',
    difficulty: 'Intermedio',
    defaultDuration: 10,
    description: 'Ejercicio para abdominales inferiores',
    instructions: '1. Acuéstate boca arriba\n2. Eleva las piernas rectas hacia el techo\n3. Baja con control sin tocar el suelo\n4. Mantén la espalda baja pegada al suelo'
  },
  {
    id: 'core-5',
    name: 'Russian Twists',
    category: 'Core',
    caloriesPerMinute: 7,
    intensity: 'moderate',
    muscleGroups: ['Oblicuos', 'Core'],
    equipment: 'Ninguno o Peso',
    difficulty: 'Intermedio',
    defaultDuration: 10,
    description: 'Ejercicio rotacional para oblicuos',
    instructions: '1. Siéntate con las rodillas flexionadas\n2. Inclínate ligeramente hacia atrás\n3. Gira el torso de lado a lado\n4. Mantén el core activado'
  },
  {
    id: 'core-6',
    name: 'Plancha Lateral (Side Plank)',
    category: 'Core',
    caloriesPerMinute: 5,
    intensity: 'moderate',
    muscleGroups: ['Oblicuos', 'Core'],
    equipment: 'Ninguno',
    difficulty: 'Intermedio',
    defaultDuration: 5,
    description: 'Ejercicio isométrico para oblicuos',
    instructions: '1. Apóyate sobre un antebrazo de lado\n2. Mantén el cuerpo en línea recta\n3. Aprieta los oblicuos\n4. Mantén la posición'
  },
  {
    id: 'core-7',
    name: 'Dead Bug',
    category: 'Core',
    caloriesPerMinute: 5,
    intensity: 'low',
    muscleGroups: ['Core', 'Abdominales'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Ejercicio de estabilidad del core',
    instructions: '1. Acuéstate boca arriba con brazos y piernas arriba\n2. Baja un brazo y la pierna opuesta\n3. Alterna los lados\n4. Mantén la espalda baja pegada al suelo'
  },
  {
    id: 'core-8',
    name: 'Mountain Climbers',
    category: 'Core',
    caloriesPerMinute: 14,
    intensity: 'high',
    muscleGroups: ['Core', 'Abdominales', 'Hombros'],
    equipment: 'Ninguno',
    difficulty: 'Intermedio',
    defaultDuration: 10,
    description: 'Ejercicio dinámico de core y cardio',
    instructions: '1. Posición de plancha\n2. Lleva las rodillas al pecho alternadamente\n3. Mantén el core apretado\n4. Mantén un ritmo rápido'
  },
  {
    id: 'core-9',
    name: 'V-ups',
    category: 'Core',
    caloriesPerMinute: 9,
    intensity: 'high',
    muscleGroups: ['Abdominales', 'Core'],
    equipment: 'Ninguno',
    difficulty: 'Avanzado',
    defaultDuration: 8,
    description: 'Ejercicio avanzado para abdominales',
    instructions: '1. Acuéstate boca arriba\n2. Eleva simultáneamente brazos y piernas\n3. Toca los pies en la posición V\n4. Baja con control'
  },
  {
    id: 'core-10',
    name: 'Hollow Body Hold',
    category: 'Core',
    caloriesPerMinute: 6,
    intensity: 'moderate',
    muscleGroups: ['Core', 'Abdominales'],
    equipment: 'Ninguno',
    difficulty: 'Intermedio',
    defaultDuration: 5,
    description: 'Ejercicio isométrico de gimnasia',
    instructions: '1. Acuéstate boca arriba\n2. Eleva ligeramente hombros y piernas\n3. Mantén la espalda baja pegada al suelo\n4. Mantén la posición'
  },

  // YOGA & FLEXIBILITY
  {
    id: 'yoga-1',
    name: 'Saludo al Sol (Sun Salutation)',
    category: 'Yoga',
    caloriesPerMinute: 3,
    intensity: 'low',
    muscleGroups: ['Cuerpo Completo'],
    equipment: 'Mat de Yoga',
    difficulty: 'Principiante',
    defaultDuration: 15,
    description: 'Secuencia fundamental de yoga',
    instructions: '1. Fluye a través de 12 posturas\n2. Sincroniza con la respiración\n3. Mantén movimientos suaves\n4. Repite varias veces'
  },
  {
    id: 'yoga-2',
    name: 'Guerrero I (Warrior I)',
    category: 'Yoga',
    caloriesPerMinute: 3,
    intensity: 'low',
    muscleGroups: ['Piernas', 'Core', 'Hombros'],
    equipment: 'Mat de Yoga',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Postura de fuerza y equilibrio',
    instructions: '1. Pierna delantera flexionada a 90 grados\n2. Pierna trasera extendida\n3. Brazos arriba\n4. Mantén la postura'
  },
  {
    id: 'yoga-3',
    name: 'Perro Boca Abajo (Downward Dog)',
    category: 'Yoga',
    caloriesPerMinute: 3,
    intensity: 'low',
    muscleGroups: ['Hombros', 'Espalda', 'Isquiotibiales'],
    equipment: 'Mat de Yoga',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Postura de descanso activo',
    instructions: '1. Forma una V invertida con el cuerpo\n2. Empuja las caderas hacia arriba\n3. Presiona los talones hacia el suelo\n4. Relaja el cuello'
  },
  {
    id: 'yoga-4',
    name: 'Postura del Árbol (Tree Pose)',
    category: 'Yoga',
    caloriesPerMinute: 2,
    intensity: 'low',
    muscleGroups: ['Piernas', 'Core'],
    equipment: 'Mat de Yoga',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Postura de equilibrio',
    instructions: '1. Equilibrio sobre una pierna\n2. Coloca el otro pie en el muslo o pantorrilla\n3. Manos en posición de oración\n4. Mantén la mirada fija'
  },
  {
    id: 'yoga-5',
    name: 'Postura del Niño (Child\'s Pose)',
    category: 'Yoga',
    caloriesPerMinute: 2,
    intensity: 'low',
    muscleGroups: ['Espalda', 'Caderas'],
    equipment: 'Mat de Yoga',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Postura de descanso y estiramiento',
    instructions: '1. Arrodíllate y siéntate sobre los talones\n2. Extiende los brazos hacia adelante\n3. Baja el torso al suelo\n4. Relájate y respira'
  },
  {
    id: 'yoga-6',
    name: 'Vinyasa Flow',
    category: 'Yoga',
    caloriesPerMinute: 4,
    intensity: 'moderate',
    muscleGroups: ['Cuerpo Completo'],
    equipment: 'Mat de Yoga',
    difficulty: 'Intermedio',
    defaultDuration: 30,
    description: 'Secuencia fluida de posturas',
    instructions: '1. Fluye entre posturas\n2. Sincroniza movimiento y respiración\n3. Mantén el ritmo constante\n4. Modifica según necesites'
  },
  {
    id: 'yoga-7',
    name: 'Postura del Puente (Bridge Pose)',
    category: 'Yoga',
    caloriesPerMinute: 3,
    intensity: 'low',
    muscleGroups: ['Glúteos', 'Espalda', 'Core'],
    equipment: 'Mat de Yoga',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Postura de apertura de pecho',
    instructions: '1. Acuéstate boca arriba\n2. Eleva las caderas\n3. Entrelaza las manos debajo\n4. Mantén la postura'
  },
  {
    id: 'yoga-8',
    name: 'Torsión Espinal (Spinal Twist)',
    category: 'Yoga',
    caloriesPerMinute: 2,
    intensity: 'low',
    muscleGroups: ['Espalda', 'Oblicuos'],
    equipment: 'Mat de Yoga',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Postura de desintoxicación',
    instructions: '1. Siéntate con las piernas cruzadas\n2. Gira el torso hacia un lado\n3. Coloca la mano opuesta en la rodilla\n4. Respira profundamente'
  },
  {
    id: 'yoga-9',
    name: 'Cobra (Cobra Pose)',
    category: 'Yoga',
    caloriesPerMinute: 3,
    intensity: 'low',
    muscleGroups: ['Espalda', 'Pecho', 'Hombros'],
    equipment: 'Mat de Yoga',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Postura de extensión de espalda',
    instructions: '1. Acuéstate boca abajo\n2. Coloca las manos bajo los hombros\n3. Levanta el pecho del suelo\n4. Mantén los codos ligeramente flexionados'
  },
  {
    id: 'yoga-10',
    name: 'Paloma (Pigeon Pose)',
    category: 'Yoga',
    caloriesPerMinute: 2,
    intensity: 'low',
    muscleGroups: ['Caderas', 'Glúteos'],
    equipment: 'Mat de Yoga',
    difficulty: 'Intermedio',
    defaultDuration: 10,
    description: 'Postura de apertura de caderas',
    instructions: '1. Lleva una pierna adelante flexionada\n2. Extiende la otra pierna atrás\n3. Baja el torso hacia adelante\n4. Respira en el estiramiento'
  },

  // HIIT & FUNCTIONAL
  {
    id: 'hiit-1',
    name: 'Tabata',
    category: 'HIIT',
    caloriesPerMinute: 20,
    intensity: 'extreme',
    muscleGroups: ['Cuerpo Completo'],
    equipment: 'Ninguno',
    difficulty: 'Avanzado',
    defaultDuration: 4,
    description: 'Protocolo HIIT de alta intensidad',
    instructions: '1. 20 segundos de trabajo máximo\n2. 10 segundos de descanso\n3. Repite 8 rondas\n4. Da todo en cada intervalo'
  },
  {
    id: 'hiit-2',
    name: 'AMRAP (As Many Rounds As Possible)',
    category: 'HIIT',
    caloriesPerMinute: 18,
    intensity: 'extreme',
    muscleGroups: ['Cuerpo Completo'],
    equipment: 'Varía',
    difficulty: 'Avanzado',
    defaultDuration: 20,
    description: 'Completa tantas rondas como puedas',
    instructions: '1. Elige 3-5 ejercicios\n2. Completa el circuito\n3. Repite sin descanso\n4. Cuenta las rondas completadas'
  },
  {
    id: 'hiit-3',
    name: 'EMOM (Every Minute On the Minute)',
    category: 'HIIT',
    caloriesPerMinute: 17,
    intensity: 'high',
    muscleGroups: ['Cuerpo Completo'],
    equipment: 'Varía',
    difficulty: 'Avanzado',
    defaultDuration: 20,
    description: 'Ejercicio al inicio de cada minuto',
    instructions: '1. Completa el ejercicio al inicio del minuto\n2. Descansa el tiempo restante\n3. Repite cada minuto\n4. Mantén la intensidad'
  },
  {
    id: 'hiit-4',
    name: 'Circuito de Peso Corporal',
    category: 'HIIT',
    caloriesPerMinute: 15,
    intensity: 'high',
    muscleGroups: ['Cuerpo Completo'],
    equipment: 'Ninguno',
    difficulty: 'Intermedio',
    defaultDuration: 25,
    description: 'Circuito de ejercicios sin equipo',
    instructions: '1. 5-6 ejercicios de peso corporal\n2. 45 segundos de trabajo\n3. 15 segundos de descanso\n4. Completa 3-4 rondas'
  },
  {
    id: 'hiit-5',
    name: 'Sprint Intervals',
    category: 'HIIT',
    caloriesPerMinute: 22,
    intensity: 'extreme',
    muscleGroups: ['Piernas', 'Core'],
    equipment: 'Ninguno',
    difficulty: 'Avanzado',
    defaultDuration: 15,
    description: 'Intervalos de sprint de alta intensidad',
    instructions: '1. Sprint a máxima velocidad 30 segundos\n2. Camina o trota 60-90 segundos\n3. Repite 8-10 veces\n4. Calienta y enfría adecuadamente'
  },

  // SPORTS & ACTIVITIES
  {
    id: 'sport-1',
    name: 'Fútbol (Soccer)',
    category: 'Deportes',
    caloriesPerMinute: 11,
    intensity: 'high',
    muscleGroups: ['Piernas', 'Core', 'Cuerpo Completo'],
    equipment: 'Balón',
    difficulty: 'Intermedio',
    defaultDuration: 60,
    description: 'Deporte de equipo cardiovascular',
    instructions: '1. Calienta adecuadamente\n2. Mantén la hidratación\n3. Usa técnica apropiada\n4. Enfría después del juego'
  },
  {
    id: 'sport-2',
    name: 'Baloncesto (Basketball)',
    category: 'Deportes',
    caloriesPerMinute: 12,
    intensity: 'high',
    muscleGroups: ['Piernas', 'Core', 'Brazos'],
    equipment: 'Balón',
    difficulty: 'Intermedio',
    defaultDuration: 45,
    description: 'Deporte de alta intensidad con saltos',
    instructions: '1. Calienta las articulaciones\n2. Practica movimientos básicos\n3. Mantén la intensidad\n4. Hidrátate regularmente'
  },
  {
    id: 'sport-3',
    name: 'Tenis',
    category: 'Deportes',
    caloriesPerMinute: 10,
    intensity: 'moderate',
    muscleGroups: ['Brazos', 'Piernas', 'Core'],
    equipment: 'Raqueta y Pelota',
    difficulty: 'Intermedio',
    defaultDuration: 60,
    description: 'Deporte de raqueta con movimientos explosivos',
    instructions: '1. Calienta hombros y muñecas\n2. Practica técnica de golpeo\n3. Mantén la movilidad\n4. Estira después'
  },
  {
    id: 'sport-4',
    name: 'Voleibol (Volleyball)',
    category: 'Deportes',
    caloriesPerMinute: 9,
    intensity: 'moderate',
    muscleGroups: ['Piernas', 'Brazos', 'Hombros'],
    equipment: 'Balón',
    difficulty: 'Intermedio',
    defaultDuration: 45,
    description: 'Deporte de equipo con saltos',
    instructions: '1. Calienta las piernas\n2. Practica técnica de recepción\n3. Salta con técnica\n4. Trabaja en equipo'
  },
  {
    id: 'sport-5',
    name: 'Artes Marciales',
    category: 'Deportes',
    caloriesPerMinute: 13,
    intensity: 'high',
    muscleGroups: ['Cuerpo Completo'],
    equipment: 'Varía',
    difficulty: 'Intermedio',
    defaultDuration: 45,
    description: 'Entrenamiento de combate y defensa',
    instructions: '1. Calienta todo el cuerpo\n2. Practica técnicas básicas\n3. Mantén la concentración\n4. Respeta a tu compañero'
  },
  {
    id: 'sport-6',
    name: 'Escalada (Rock Climbing)',
    category: 'Deportes',
    caloriesPerMinute: 11,
    intensity: 'high',
    muscleGroups: ['Brazos', 'Espalda', 'Core', 'Piernas'],
    equipment: 'Muro de Escalada',
    difficulty: 'Avanzado',
    defaultDuration: 40,
    description: 'Deporte de fuerza y técnica',
    instructions: '1. Usa equipo de seguridad\n2. Planifica tu ruta\n3. Usa las piernas para empujar\n4. Descansa entre intentos'
  },
  {
    id: 'sport-7',
    name: 'Baile (Dance)',
    category: 'Deportes',
    caloriesPerMinute: 7,
    intensity: 'moderate',
    muscleGroups: ['Cuerpo Completo'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 45,
    description: 'Actividad cardiovascular divertida',
    instructions: '1. Calienta con movimientos suaves\n2. Sigue el ritmo de la música\n3. Disfruta el movimiento\n4. Mantén la hidratación'
  },
  {
    id: 'sport-8',
    name: 'Paddle/Kayak',
    category: 'Deportes',
    caloriesPerMinute: 8,
    intensity: 'moderate',
    muscleGroups: ['Brazos', 'Espalda', 'Core'],
    equipment: 'Kayak o Paddle',
    difficulty: 'Intermedio',
    defaultDuration: 60,
    description: 'Deporte acuático de resistencia',
    instructions: '1. Usa chaleco salvavidas\n2. Aprende técnica de remo\n3. Mantén el ritmo\n4. Disfruta la naturaleza'
  },
  {
    id: 'sport-9',
    name: 'Golf',
    category: 'Deportes',
    caloriesPerMinute: 5,
    intensity: 'low',
    muscleGroups: ['Core', 'Brazos', 'Piernas'],
    equipment: 'Palos de Golf',
    difficulty: 'Intermedio',
    defaultDuration: 180,
    description: 'Deporte de precisión y caminata',
    instructions: '1. Calienta antes de jugar\n2. Practica el swing\n3. Camina entre hoyos\n4. Mantén la concentración'
  },
  {
    id: 'sport-10',
    name: 'Patinaje (Skating)',
    category: 'Deportes',
    caloriesPerMinute: 9,
    intensity: 'moderate',
    muscleGroups: ['Piernas', 'Glúteos', 'Core'],
    equipment: 'Patines',
    difficulty: 'Intermedio',
    defaultDuration: 40,
    description: 'Actividad cardiovascular sobre ruedas',
    instructions: '1. Usa equipo de protección\n2. Practica el equilibrio\n3. Mantén las rodillas flexionadas\n4. Disfruta el deslizamiento'
  },

  // STRETCHING & MOBILITY
  {
    id: 'stretch-1',
    name: 'Estiramiento de Isquiotibiales',
    category: 'Estiramiento',
    caloriesPerMinute: 2,
    intensity: 'low',
    muscleGroups: ['Isquiotibiales'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Estiramiento para la parte posterior del muslo',
    instructions: '1. Siéntate con una pierna extendida\n2. Inclínate hacia adelante\n3. Mantén la espalda recta\n4. Respira profundamente'
  },
  {
    id: 'stretch-2',
    name: 'Estiramiento de Cuádriceps',
    category: 'Estiramiento',
    caloriesPerMinute: 2,
    intensity: 'low',
    muscleGroups: ['Cuádriceps'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Estiramiento para la parte frontal del muslo',
    instructions: '1. De pie, lleva el talón al glúteo\n2. Mantén las rodillas juntas\n3. Mantén el equilibrio\n4. Respira normalmente'
  },
  {
    id: 'stretch-3',
    name: 'Estiramiento de Pecho',
    category: 'Estiramiento',
    caloriesPerMinute: 2,
    intensity: 'low',
    muscleGroups: ['Pecho', 'Hombros'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Estiramiento para apertura de pecho',
    instructions: '1. Entrelaza las manos detrás de la espalda\n2. Levanta los brazos\n3. Abre el pecho\n4. Mantén la postura'
  },
  {
    id: 'stretch-4',
    name: 'Estiramiento de Hombros',
    category: 'Estiramiento',
    caloriesPerMinute: 2,
    intensity: 'low',
    muscleGroups: ['Hombros'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Estiramiento para movilidad de hombros',
    instructions: '1. Lleva un brazo cruzado al pecho\n2. Presiona con el otro brazo\n3. Mantén los hombros relajados\n4. Respira profundamente'
  },
  {
    id: 'stretch-5',
    name: 'Estiramiento de Espalda Baja',
    category: 'Estiramiento',
    caloriesPerMinute: 2,
    intensity: 'low',
    muscleGroups: ['Espalda Baja'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Estiramiento para aliviar tensión lumbar',
    instructions: '1. Acuéstate boca arriba\n2. Lleva las rodillas al pecho\n3. Abraza las piernas\n4. Respira profundamente'
  },
  {
    id: 'stretch-6',
    name: 'Estiramiento de Cuello',
    category: 'Estiramiento',
    caloriesPerMinute: 1,
    intensity: 'low',
    muscleGroups: ['Cuello'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 8,
    description: 'Estiramiento para aliviar tensión cervical',
    instructions: '1. Inclina la cabeza hacia un lado\n2. Mantén los hombros relajados\n3. Respira profundamente\n4. Alterna los lados'
  },
  {
    id: 'stretch-7',
    name: 'Estiramiento de Glúteos',
    category: 'Estiramiento',
    caloriesPerMinute: 2,
    intensity: 'low',
    muscleGroups: ['Glúteos', 'Caderas'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Estiramiento para glúteos y caderas',
    instructions: '1. Acuéstate boca arriba\n2. Cruza un tobillo sobre la rodilla opuesta\n3. Tira de la pierna hacia el pecho\n4. Respira en el estiramiento'
  },
  {
    id: 'stretch-8',
    name: 'Estiramiento de Pantorrillas',
    category: 'Estiramiento',
    caloriesPerMinute: 2,
    intensity: 'low',
    muscleGroups: ['Pantorrillas'],
    equipment: 'Ninguno',
    difficulty: 'Principiante',
    defaultDuration: 10,
    description: 'Estiramiento para las pantorrillas',
    instructions: '1. Coloca un pie adelante\n2. Presiona el talón trasero al suelo\n3. Mantén la pierna trasera recta\n4. Inclínate hacia adelante'
  },
  {
    id: 'stretch-9',
    name: 'Movilidad de Cadera',
    category: 'Estiramiento',
    caloriesPerMinute: 3,
    intensity: 'low',
    muscleGroups: ['Caderas', 'Glúteos'],
    equipment: 'Ninguno',
    difficulty: 'Intermedio',
    defaultDuration: 12,
    description: 'Ejercicios de movilidad para caderas',
    instructions: '1. Realiza círculos con las caderas\n2. Mantén movimientos controlados\n3. Aumenta el rango gradualmente\n4. Respira normalmente'
  },
  {
    id: 'stretch-10',
    name: 'Foam Rolling',
    category: 'Estiramiento',
    caloriesPerMinute: 3,
    intensity: 'low',
    muscleGroups: ['Cuerpo Completo'],
    equipment: 'Foam Roller',
    difficulty: 'Principiante',
    defaultDuration: 15,
    description: 'Auto-masaje miofascial',
    instructions: '1. Rueda lentamente sobre el músculo\n2. Detente en puntos tensos\n3. Respira profundamente\n4. Evita articulaciones y huesos'
  }
];

/**
 * Get exercises by category
 */
export const getExercisesByCategory = (category) => {
  return exerciseDatabase?.filter(exercise => exercise?.category === category);
};

/**
 * Get exercises by intensity
 */
export const getExercisesByIntensity = (intensity) => {
  return exerciseDatabase?.filter(exercise => exercise?.intensity === intensity);
};

/**
 * Get exercises by difficulty
 */
export const getExercisesByDifficulty = (difficulty) => {
  return exerciseDatabase?.filter(exercise => exercise?.difficulty === difficulty);
};

/**
 * Get exercises by muscle group
 */
export const getExercisesByMuscleGroup = (muscleGroup) => {
  return exerciseDatabase?.filter(exercise => 
    exercise?.muscleGroups?.includes(muscleGroup)
  );
};

/**
 * Get exercises that don't require equipment
 */
export const getBodyweightExercises = () => {
  return exerciseDatabase?.filter(exercise => exercise?.equipment === 'Ninguno');
};

/**
 * Calculate total calories for an exercise
 */
export const calculateExerciseCalories = (exerciseId, durationMinutes) => {
  const exercise = exerciseDatabase?.find(ex => ex?.id === exerciseId);
  if (!exercise) return 0;
  return Math.round(exercise?.caloriesPerMinute * durationMinutes);
};

/**
 * Get all unique categories
 */
export const getCategories = () => {
  return [...new Set(exerciseDatabase.map(ex => ex.category))];
};

/**
 * Get all unique muscle groups
 */
export const getMuscleGroups = () => {
  const allMuscleGroups = exerciseDatabase?.flatMap(ex => ex?.muscleGroups);
  return [...new Set(allMuscleGroups)];
};

/**
 * Search exercises by name
 */
export const searchExercises = (query) => {
  const lowerQuery = query?.toLowerCase();
  return exerciseDatabase?.filter(exercise => 
    exercise?.name?.toLowerCase()?.includes(lowerQuery) ||
    exercise?.description?.toLowerCase()?.includes(lowerQuery)
  );
};